
const ErrorCodes = {
    ERROR_100:'Frontend error',
    ERROR_401:'Invalid Username and/or Password',
    ERROR_500:'Network Error',
    ERROR_999:'Oops! Something went wrong.'
  }
  
export default ErrorCodes